import { abi } from './abi';
import { SERVICE_TYPE_MANAGER_CONTRACT_ADDRESS } from './constants';
export class ServiceTypeManager {
    constructor(client, { address } = {}) {
        this.getGovernanceAddress = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getGovernanceAddress'
        });
        this.getServiceTypeInfo = ({ serviceType }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getServiceTypeInfo',
            args: [serviceType]
        });
        this.getValidServiceTypes = () => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getValidServiceTypes'
        });
        this.serviceTypeIsValid = ({ serviceType }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'serviceTypeIsValid',
            args: [serviceType]
        });
        this.getVersion = ({ serviceType, versionIndex }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getVersion',
            args: [serviceType, versionIndex]
        });
        this.getCurrentVersion = ({ serviceType }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getCurrentVersion',
            args: [serviceType]
        });
        this.getNumberOfVersions = ({ serviceType }) => this.client.readContract({
            address: this.address,
            abi,
            functionName: 'getNumberOfVersions',
            args: [serviceType]
        });
        // TODO - writes
        this.setGovernanceAddress = null;
        this.addServiceType = null;
        this.removeServiceType = null;
        this.setServiceVersion = null;
        this.serviceVersionIsValid = null;
        this.client = client;
        this.address = address ?? SERVICE_TYPE_MANAGER_CONTRACT_ADDRESS;
    }
}
//# sourceMappingURL=serviceTypeManager.js.map